import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import ClientTimestamp from 'app/components/common/client-timestamp';
import Icon            from 'app/components/common/icon';
import RteViewer       from 'app/components/common/rich-text/viewer';
import EmpImage        from 'app/components/company-admin/common/emp-image';
import Comment         from 'app/components/company-admin/grant-system/comment';
import NewComment      from 'app/components/company-admin/grant-system/comments-new';
import RubricScore     from 'app/components/company-admin/grant-system/rubric/score';
import GrantSysDuck    from 'app/ducks/company-admin/grant-system';
import format          from 'app/helpers/format';
import helpers         from 'app/helpers/grant-system';

const {TaskTypes, TimelineTypes: TT} = helpers;

const empName = (employee) => {
  if (!employee) return 'Someone';
  const name = [employee.firstName, employee.lastName].filter(Boolean).join(' ');
  return name || employee.email || 'Someone';
};



class TimelineEvent extends React.PureComponent {

  get type()    { return this.props.event.type    || null; }
  get by()      { return this.props.event.by      || null; }
  get task()    { return this.props.event.task    || null; }
  get ass()     { return this.props.event.ass     || null; }
  get comment() { return this.props.event.comment || null; }
  get stage()   { return this.props.event.stage   || null; }
  get app()     { return this.props.event.app     || null; }
  get ts()      { return this.props.event.ts      || 0; }

  get resultDetails() {
    return null;
    // return helpers.getTaskResultDetails(this.ass);
  }

  get IconComp() {
    const {type, resultDetails} = this;
    if (type === TT.COMMENT) return Icon.MessageBubbleEmpty;
    if (type === TT.ATTACHMENT) return Icon.Attachment1;
    if (type === TT.ASSIGNMENT) return Icon.SynchronizeArrows1;
    if (type === TT.NEW_STAGE) return Icon.DataTransferDiagonal;
    if (type === TT.SUBMITTED) return Icon.PenWritePaper;
    if (type === TT.TASK_RESULT) {
      return Icon.ListNumbers;
      // if (!resultDetails) return Icon.ListNumbers;
      // const {isPos, isNeg, taskType} = resultDetails;
      // if (taskType === TaskTypes.PAYMENT) return Icon.AccountingBill;
      // if ([TaskTypes.PASS_FAIL, TaskTypes.VOTE].includes(taskType)) {
      //   if (isPos) return Icon.Like;
      //   if (isNeg) return Icon.Dislike;
      //   return Icon.ListNumbers;
      // }
      // if (taskType === TaskTypes.FINAL) {
      //   return isPos ? Icon.CheckCircle1 : Icon.Remove;
      // }
      // return Icon.ListNumbers;
    }
    return null;
  }

  renderHeadline() {
    const {type, by, task, ass, comment, stage, app} = this;
    if (type === TT.ASSIGNMENT) return (<>
      {`${task.title} assigned to ${empName(ass.employee)}`}
    </>);
    if (type === TT.TASK_RESULT) return (<>
      {`${task.title} submitted`}
      {/* {!!resultDetails && ( */}
      {/*   <div className={`ca-gapp-tlev-top-headline-badge _bg-${resultDetails.color}`}>{resultDetails.badgeVal}</div> */}
      {/* )} */}
    </>);
    if (type === TT.SUBMITTED) return (<>
      {`Application #${app.number} submitted`}
    </>);
    if (type === TT.ATTACHMENT) return (<>
      {`${format.pluralize('Attachment', (comment?.files?.length || 0))}`}
    </>);
    if (type === TT.COMMENT) {
      const questionTitle = comment?.formAnswer?.fieldConfig?.title;
      return questionTitle ? `Comment on: ${format.truncate(questionTitle, 70)}` : 'Comment';
    }
    if (type === TT.NEW_STAGE) return (<>
      {`Moved to stage`}
      <div className="ca-gapp-tlev-top-headline-badge" style={{backgroundColor: stage.color}}>{stage.title}</div>
    </>);
    return null;
  }

  renderBodyTaskResult() {
    const {type, ass, app} = this;
    if (type !== TT.TASK_RESULT) return null;
    if (!ass) return null;
    const comment = ass.mainComment;

    return (
      <div className={`ca-gapp-tlev-body`}>
        <div className="ca-gapp-tlev-score-con">
          <RubricScore score={ass.score} />
        </div>
        {!!comment && <Comment comment={comment} appId={app.id} />}
      </div>
    );
  }

  renderBodyComment() {
    const {comment} = this;
    if (![TT.COMMENT, TT.ATTACHMENT].includes(this.type) || !comment) return null;

    return (
      <div className={`ca-gapp-tlev-body`}>
        <Comment comment={comment} appId={this.app.id} />
      </div>
    );
  }

  renderBody() {
    if (this.type === TT.TASK_RESULT) return this.renderBodyTaskResult();
    if (this.type === TT.COMMENT) return this.renderBodyComment();
    if (this.type === TT.ATTACHMENT) return this.renderBodyComment();
    return null;
  }

  render() {
    const {IconComp} = this;
    const isTypeSubmitted = this.type === TT.SUBMITTED;
    const byName = (() => {
      if (this.by) return empName(this.by);
      if (isTypeSubmitted) return empName(this.app.user);
      return null;
    })();

    return (
      <div className={`ca-gapp-tlev type-${this.type}`}>
        <div className="ca-gapp-tlev-icon-con1">
          <div className="ca-gapp-tlev-icon-con2">
            {!!IconComp && <IconComp className="ca-gapp-tlev-icon" />}
          </div>
        </div>
        <div className="ca-gapp-tlev-main">
          <div className="ca-gapp-tlev-top">
            <div className="ca-gapp-tlev-top-headline">
              {this.renderHeadline()}
            </div>
            <ClientTimestamp.DateTimeTz timestamp={this.ts} className="ca-gapp-tlev-top-ts" />
          </div>
          {!!byName && (
            <div className="ca-gapp-tlev-by">
              <EmpImage employee={this.by} user={isTypeSubmitted ? this.app?.user : null} className="ca-gapp-tlev-by-img" />
              <span>{byName}</span>
            </div>
          )}
          {this.renderBody()}
        </div>
      </div>
    );
  }

}



class AppTimeline extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      tab: 'all',
    };
  }

  onClickTab(tab, event) {
    event.preventDefault();
    this.setState({tab});
  }

  render() {
    const {timeline, app} = this.props;
    const {tab: currentTab} = this.state;
    if (!timeline) return null;

    const showAll = !Object.values(TT).includes(currentTab);
    const includeTaskResults = showAll || (currentTab === TT.TASK_RESULT);

    const filteredEvents = (() => {
      return timeline.filter((ev) => {
        const isCommentish = [TT.COMMENT, TT.ATTACHMENT].includes(ev.type);
        // don't show the main comment associated with an assignment if timeline is showing task results, cuz the task result will show that comment
        const isAssMainComment = isCommentish && (ev.comment.grantAssignmentId && !ev.comment.formAnswerId);
        if (isAssMainComment && includeTaskResults) return false;
        // comments tab should show attachment types if there's also a comment body
        if (currentTab === TT.COMMENT && ev.type === TT.ATTACHMENT) {
          return !!(ev.comment?.body || '').trim();
        }
        if (showAll) return true;
        return ev.type === currentTab;
      });
    })();

    const activeClass = (tab) => (tab === currentTab) ? 'active' : '';

    const showCommentForm = !!(app && [TT.COMMENT, TT.ATTACHMENT, 'all'].includes(currentTab));

    return (
      <div className="ca-box ca-gapp-timeline">
        <div className="ca-box-tabs2">
          <div className="ca-box-tabs2-tabs">
            <a href="#" onClick={this.onClickTab.bind(this, 'all')} className={`ca-box-tabs2-tab ${activeClass('all')}`}>Everything</a>
            <a href="#" onClick={this.onClickTab.bind(this, TT.TASK_RESULT)} className={`ca-box-tabs2-tab ${activeClass(TT.TASK_RESULT)}`}>Task Completions</a>
            <a href="#" onClick={this.onClickTab.bind(this, TT.COMMENT)} className={`ca-box-tabs2-tab ${activeClass(TT.COMMENT)}`}>Comments</a>
            <a href="#" onClick={this.onClickTab.bind(this, TT.ATTACHMENT)} className={`ca-box-tabs2-tab ${activeClass(TT.ATTACHMENT)}`}>Attachments</a>
          </div>
        </div>
        <div className="ca-box-body">
          {!filteredEvents.length && (
            <p className="_italic _clr-mid">Nothing to see here yet.</p>
          )}
          {filteredEvents.map((event) => {
            const key = `${event.key}-${event.type}`;
            return <TimelineEvent key={key} event={event} />;
          })}
        </div>
        {showCommentForm && (<>
          <div style={{marginLeft: 44}}>
            <div className="ca-box-header">
              <h1 className="ca-box-header-title">Add a comment or attachment</h1>
            </div>
            <div className="ca-box-subheader _clr-mid _italic">Comments are internal - applicants do not see them.</div>
            <div className="ca-box-body">
              <NewComment appId={app.id} startCollapsed />
            </div>
          </div>
        </>)}
      </div>
    );
  }

}

AppTimeline.propTypes = {
  timeline: PropTypes.array,
};

const stateToProps = (state) => ({
  app: GrantSysDuck.Slx.pathApp(state),
  timeline: GrantSysDuck.Slx.appTimeline(state, GrantSysDuck.Slx.pathApp(state)),
});

export default connect(stateToProps)(AppTimeline);
